import {StyleSheet, Text} from "react-native";
import {Color} from "@/lib/styles";

type Props = {
    error: Error,
}

// Outer wrapper container for all pages.
export default function ErrorMessage({error}: Props) {
    const hint = errorHint(error);
    let text = error.message;
    if (hint) {
        text = hint + "\n\n" + "Feilmelding:\n" + text;
    }
    return (
        <Text style={styles.text}>{text.trim()}</Text>
    );
}

function errorHint(error: Error): string | null {
    if (error.name === "ApiError") {
        return null;
    } else if (error.name === "NetworkError" || error.message.startsWith("NetworkError")) {
        return "Klarer ikke snakke med serveren.\n\nSjekk at du er tilkoblet Internett og prøv igjen.";
    }
    return null;
}

const styles = StyleSheet.create({
    text: {
        width: "100%",
        borderWidth: 2,
        borderColor: Color.Red,
        borderRadius: 8,
        padding: 16,
        fontSize: 16,
        color: Color.PrimaryText,
    }
});